export type BackAction = 'navigate' | 'save' | 'confirm-discard';

export interface BackDecisionInput {
  isDirty: boolean;
  isValid: boolean;
}

// One rule for every step: you can always go back, but unsaved edits only survive
// by being saved. Anything that cannot be saved is discarded, with a prompt first.
export const decideBackAction = ({ isDirty, isValid }: BackDecisionInput): BackAction => {
  if (!isDirty) return 'navigate';
  if (isValid) return 'save';

  return 'confirm-discard';
};

export type PostSaveAction = 'navigate' | 'stay' | 'confirm-discard';

export interface PostSaveDecisionInput {
  /** Did the save actually persist? */
  saved: boolean;
  /** Did the user cancel the revert-to-Draft prompt rather than the server reject it? */
  revertDeclined: boolean;
}

// What Back does once the save it attempted comes back. A save that did not happen is
// not automatically a failure: declining the revert-to-Draft prompt means the user chose
// to keep the project Submitted and stay where they are, so prompting to discard would
// offer to throw away exactly the edits they just protected. Only a save the server
// rejected reaches the discard prompt.
export const decideAfterSave = ({ saved, revertDeclined }: PostSaveDecisionInput): PostSaveAction => {
  if (saved) return 'navigate';
  if (revertDeclined) return 'stay';

  return 'confirm-discard';
};
